const ProfileView = async () => import('@/views/employee/ProfileView.vue')

/** @type {import('vue-router').RouteRecordRaw[]} */
export default [
  {
    path: '/employee/:slugOrId',
    name: 'employee_profile',
    component: ProfileView,
    props: true
  }
]
